import { styled } from 'styled-components';

import { cssBreakpoints, sectionPadding } from '#/theme/theme';

export const CmsPostLayout_Box_1 = styled.div`
  margin: ${sectionPadding[0]};
  flex: 1 1 auto;
  width: 100%;
  margin-top: 70px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin: ${sectionPadding[2]};
  }
`;
